import { render, staticRenderFns } from "./IPanel.vue?vue&type=template&id=43d45531&scoped=true&lang=pug"
import script from "./IPanel.vue?vue&type=script&lang=js"
export * from "./IPanel.vue?vue&type=script&lang=js"
import style0 from "./IPanel.vue?vue&type=style&index=0&id=43d45531&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d45531",
  null
  
)

export default component.exports